import { Box, CircularProgress, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { createPortal } from 'react-dom';

type CallStartOverlayProps = {
  message: string;
};

export function CallStartOverlay({ message }: CallStartOverlayProps) {
  const theme = useTheme();

  return createPortal(
    <Box
      sx={{
        position: 'fixed',
        inset: 0,
        zIndex: 10000,
        backgroundColor: 'rgba(0, 0, 0, 0.65)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '32px',
      }}
    >
      <CircularProgress size={88} thickness={3} sx={{ color: theme.palette.primary.main }} />
      <Typography
        variant='h5'
        sx={{
          color: '#fff',
          textAlign: 'center',
          maxWidth: '440px',
          px: '24px',
          fontWeight: 500,
          lineHeight: 1.4,
        }}
      >
        {message}
      </Typography>
    </Box>,
    document.body,
  );
}
